import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    ExcelExportButton,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useServiceList } from '@/modules/Service/hooks'
import { ALL_SERVICE_STATUSES } from '@/modules/Service/utils/service-list-config'
import Statistical from './Statistical'
import { SERVICE_EXCEL_COLUMNS } from '@/modules/Service/constants/excelColumns'

const AllService = () => {
    const {
        services,
        pagination,
        stateComponent,
        isFetching,
        params,
        queryParams,
        control,
        setFilter,
        searchInputProps,
        columns,
        filterItems,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useServiceList({
        type: 'all',
        serviceStatuses: ALL_SERVICE_STATUSES,
    })

    return (
        <div className="space-y-2 mt-2">
            <Statistical params={params} />

            <Paper>
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={services}
                        rowKey={(row) => String(row?.service_id)}
                        size="small"
                        resizable
                        loading={!services.length && !pagination}
                        isFetching={isFetching}
                        emptyMessage={t('no-services')}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page || 1,
                            pageSize: params.page_size || 20,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                            pageSizeOptions: [10, 20, 50, 100],
                        }}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search-service'),
                            },
                            settings: {
                                show: true,
                                storageKey: 'services-all-list',
                                actionComponents: [
                                    <ExcelExportButton
                                        key="export"
                                        apiEndpoint="services"
                                        columns={SERVICE_EXCEL_COLUMNS}
                                        queryParams={queryParams}
                                        feature="service"
                                    />,
                                ],
                            },
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default AllService
